import gql from 'graphql-tag';

import * as fragments from 'customer/components/policy/policy.query.fragments';
import { OFFER_FRAGMENT } from 'core/fragments/offer';

export const GET_POLICY_FROM_VERSION = gql`
  query getPolicyFromVersion($id: ID!, $version: String!) {
    getPolicyFromVersion(id: $id, version: $version) {
      id
      offerId
      policyType
      paymentType
      isBix
      isAgentSold
      salesRep
      bindRep
      paymentMethod
      premiumBreakdown
      webUserId
      billingDayOfMonth
      billingHoldUntil
      blockCreditCheckAtRenewal
      rateControlDate
      effectiveDate
      endDate
      fullTermPolicyEndDate
      inceptionDate
      autoRenew
      sendPaperDocuments
      renewalCreditPull
      renewalPaymentType
      renewalPaymentMethod
      renewalVariables {
        allow300KCSL
        allowForcedNonRenewal
        allowUmbrella
        allowMonthlyPayments
      }
      state
      term
      version
      premium
      surplusContribution
      rewriteReason
      cancelReason
      nonRenewReason
      cancelled
      nonRenewed
      fullTermCancel
      stripeCustomerId
      surplusContribution
      defaultCreditCard {
        id
        brand
        last4
        bankName
      }
      defaultBankAccount {
        id
        routingNumber
        accountHolder
        accountType
      }
      defaultEscrowAccount {
        mortgageHolderName
        loanNumber
        mortgageHolderAddress {
          address
          address2
          country
          state
          city
          zip
        }
        mortgageHolderEmail
        mortgageHolderFax
      }
      accountDetails {
        accountHolder
        accountType
        routingNumber
        accountNumber
      }
      bankAccounts {
        accountHolder
        accountType
        routingNumber
        accountNumber
      }
      creditCards {
        id
        brand
        last4
      }
      additionalParties {
        id
        name
        email
        relationship
        lossPayee
        address {
          address
          address2
          unit
          country
          city
          state
          zip
        }
        loanNumber
        VIN
      }
      fees {
        type
        description
        amount
        appliedDate
      }
      fromStaff
      offer {
        ...OfferFragment
      }
      versionHistory {
        version
        username
        updatedDateTime
        coverageChange
        itemsChanged
        itemsChangedAddendum
        effectiveDate
        internalNotes
        changeInPremium
        totalPrice
      }
      segments {
        segmentId
        deltaDirectives
        clarionDoorId
        startDate
        dailyRate
        segmentDays
        segmentPremium
        autoCoverage {
          policyLimitBIPD
          policyLimitUMBI
          policyLimitUIMBI
          policyLimitPIP
          policyLimitUMPD
          policyLimitMedicalPayments
          policyLimitLPD
          petInjury
          coverageEducatorAdvantage
          coverageOffPremisesExpanded
          policyLimitPIPME
          policyLimitPIPWL
          policyLimitPIPACR
          policyLimitPPI
          policyLimitIncomeLoss
          policyLimitAccidentalDeath
          policyLimitFuneralBenefits
          policyLimitExtraMedBenefits
          policyLimitTortOption
          policyLimitComboFBP
          policyLimitGuestPIP
          policyLimitNoFaultPIP
          uimAddedOn
          skipPDValidation
        }
        scheduledPersonalProperty {
          deductible
          items {
            category
            description
            value
            breakageOption
            exTheftOption
          }
        }
        premium
        includeUmbrella
        includeRenters
        includeEarthquake
        includeFlood
        earthquakeCoverage {
          policyId
        }
        floodCoverage {
          policyId
        }
        attachedHomeowners
        attachedRenters
        attachedAuto
        attachedCondo
        umbrellaCoverage {
          highRisk
          numVehiclesTotal
          numLicensedDriversUnder25
          numMotorcyclesScooters
          numATVs
          numPersonalWatercraft
          numWatercraft
          watercraftHullLengths
          numRVs
          numRentalProperties
          uninsuredMotoristLimit
          rentalPropertyAddresses {
            ...Address
          }
          numOtherProperties
          otherPropertyAddresses {
            ...Address
          }
          presenceOfBusiness
          uninsuredMotoristLimit
          liabilityCoverageLimit
          limitBIOccurrence
        }
        branchPlusPolicies {
          policyType
          policyCarrier
          policyNumber
          attestationAgent
        }
        homeCoverage {
          coverageA
          limitOverride
          limitOverrideReason
          limitOverrideBy
          limitOverrideAt
          limitOverrideRemovedBy
          limitOverrideRemovedAt
          coverageIBSC
          coverageBCPctOfA
          coverageBPctOfA
          coverageCPctOfA
          coverageDPctOfA
          coverageX
          coverageY
          coverageWaterBackup
          coverageBuildingMaterialsTheft
          coverageCourseOfConstruction
          coverageExtendedPremises
          coverageEducatorAdvantage
          coverageOffPremisesExpanded
          coverageFairRental
          coveragePetBite
          coverageRSExtended
          coverageYardAndGarden
          coverageSinkhole
          coverageOilStorageTank
          coverageBP
          coverageCA
          coverageDC
          coverageDR
          coverageF
          coverageG
          coverageJ
          coverageMI
          coverageMS
          coverageSP
          coverageST
          coverageEBSL
          homeownerProtection
          deductibleAllOther
          deductibleHurricane
          deductibleWaterBackup
          deductibleWindHail
          windHailExclusion
          minimumDeductibleValue
          minimumWindHailDeductible
          minimumWindHailDeductibleValue
          minimumHurricaneDeductible
          minimumHurricaneDeductibleValue
          interestedInSeparateWindHail
          externalPolicyId
        }
        condoCoverage {
          coverageC
          coverageA
          coverageBCPctOfC
          coverageDPctOfC
          coverageEBSL
          coverageX
          coverageY
          coverageF
          coverageJ
          coverageBP
          coverageMI
          coverageCA
          coverageSP
          coverageST
          coverageDR
          coveragePetBite
          coverageIBSC
          minimumDeductibleValue
          personalPropReimbursement
          coverageG
          coverageWaterBackup
          coverageMSALE
          coverageMS
          deductibleAllOther
        }
        global {
          affinity
          affinityGroupStem
          rateControlDate
          currentlyHomeInsured
          currentAutoAMBEST
          currentAutoCarrier
          manualInventorySubmission
          discountInventoryScore
          discountDriverScore
          discountPaperless
          discountBixMutualAffinity
          homeownersPaymentType
          homeownersPaymentMethod
          autoPaymentType
          autoPaymentMethod
          condoPaymentType
          condoPaymentMethod
          currentlyAutoInsured
          homeEffectiveDate
          autoEffectiveDate
          homeSecurityPartnerCustomerType
          employeeDiscount
          autoMegaDownPay
          homeMegaDownPay
          rentersMegaDownPay
          condoMegaDownPay
        }
        rentersCoverage {
          rentersLocation {
            ...Address
          }
          coverageCD
          coverageX
          coverageY
          deductible
        }
        condo {
          constructionType
          condoLocation {
            ...Address
          }
          condoQuality
          mortgageDetails {
            loanNumber
            mortgageHolderName
            mortgageHolderAddress {
              address
              address2
              country
              city
              state
              zip
            }
            mortgageHolderEmail
            mortgageHolderFax
            primary
            isCustom
          }
          numFullBathrooms
          numHalfBathrooms
          numOccupants
          ownershipStatus
          purchaseDate
          replacementCostEstimate {
            total
            itemized {
              calculatedValue
              type
              desc
            }
            valuationId
          }
          roofShape
          sqFt
          typeOfCondo
          typeOfEntry
          hasBasement
          buildingHasMoreThanFiveUnits
          yearBuilt
          latitude
          longitude
          fpc
          county
          fireHydrantWithin1000ft
          windstormMitigationLevel
          fpcFromLocation
          fpcOverride
          fpcOverrideValue
          fpcOverrideReason
          fpcOverrideBy
          floor
          weeksRentedOut
          hasUnitNumber
          floor
          numVehicles
          dtoName
          dtbowName
          dtbowLabel
          wildfireHazardScore
          wildfireGallagherScore
        }
        farm{
          mortgageDetails {
            loanNumber
            mortgageHolderName
            mortgageHolderAddress {
              address
              address2
              country
              city
              state
              zip
            }
            mortgageHolderEmail
            mortgageHolderFax
            primary
            isCustom
          }
        }
        cars {
          addDate
          VIN
          vehicleNumber
          year
          make
          model
          bodyType
          primaryUse
          purchaseDate
          garageLocation {
            ...Address
          }
          isGarageAddressRuleExceptionApproved
          deductibleCollision
          deductibleComprehensive
          limitUMPD
          limitRental
          limitACPE
          customEquipmentDescription
          limitIncomeLoss
          roadsideAssistance
          extendedNonOwnedCoverage
          solelyOwnedByApplicant
          statedAmount
          jointOwner
          jointOwnerName
          jointOwnerAddress {
            address
            address2
            city
            state
            zip
          }
          jointOwnerSameHousehold
          jointOwnerRelated
          jointOwnerRelationship
          ownership
          rideSharing
          confirmed
          aebStatus
          aebConfirmed
          antiTheftStatus
          antiTheftConfirmed
          blindSpotStatus
          blindSpotConfirmed
          singleAirbagStatus
          singleAirbagConfirmed
          doubleAirbagStatus
          doubleAirbagConfirmed
          coverageLoan
          assignedDriver
          userAssignedDriver
          symbolMake
          symbolModel
          symbolStyle
          symbolAux
          symbolPGS
          symbolBI
          symbolPD
          symbolMed
          symbolPIP
          symbolColl
          symbolComp
          symbolUM
          vehicleTypeCode
          vehicleHorsepowerCode
          convertible
          vehicleSymbolGroup
          rapaLiabilitySymbol1
          rapaLiabilitySymbol2
          rapaPhysDamSymbol1
          rapaPhysDamSymbol2
          rapaBodilyInjurySymbol
          rapaPropertyDamageSymbol
          rapaMedPaySymbol
          rapaComprehensiveSymbol
          rapaCollisionSymbol
          manuallyAddedSymbols
          annualMilesDriven
          hasOutstandingRecall
          brandedTitle
          brandedTitleDescription
        }
        drivers {
          ...People
        }
        nonDrivers {
          ...People
        }
        people {
          ...People
        }
        removedDrivers {
          ...People
        }
        trailers {
          VIN
          vehicleNumber
          type
          primaryUse
          year
          value
          contents
          purchaseDate
          garageLocation {
            ...Address
          }
          deductibleCollision
          deductibleComprehensive
          confirmed
          coverageLoan
          addDate
        }
        auto {
          householdMembers
          hasSetPip
          pipResidentsConfirmation
          pipEligibilityConfirmation
          pipResidentsWithQHC
          pipExcludedResidents
          pipAllResidents
          pipEveryoneOnSamePlan
          pipHealthInsuranceType
          pipAdditionalResidents
          residenceInsuranceType
        }
        home {
          basementSqFt
          basementType
          constructionType
          exteriorWallType
          garageCarCapacity
          garageType
          homeLocation {
            ...Address
          }
          homeQuality
          mortgageDetails {
            loanNumber
            mortgageHolderAddress {
              address
              address2
              country
              city
              state
              zip
            }
            mortgageHolderName
            primary
            mortgageHolderEmail
            mortgageHolderFax
            isCustom
          }
          numFamiliesInDwelling
          numFireplaces
          numFullBathrooms
          numHalfBathrooms
          numOccupants
          numStories
          numWoodBurningStoves
          ownershipStatus
          purchaseDate
          replacementCostEstimate {
            total
            itemized {
              calculatedValue
              type
              desc
            }
            valuationId
          }
          roofOriginal
          roofShape
          roofType
          roofYear
          roofReplacementYearMax
          roofDeck
          roofCover
          roofDeckAttachment
          roofToWallConnection
          openingProtection
          roofSWR
          sqFt
          originalSqFt
          swimmingPool
          typeOfHome
          yearBuilt
          latitude
          longitude
          county
          fireHydrantWithin1000ft
          porchCode
          porchSqFt
          hasTrampoline
          constructionStyle
          fpc
          fpcFromLocation
          fpcOverride
          fpcOverrideValue
          fpcOverrideReason
          fpcOverrideBy
          wildfireHazardScore
          wildfireGallagherScore
          dtoName
          dtbowName
          dtbowLabel
          windstormMitigationLevel
          stormShutters
          fortifiedHome
        }
        connectedHome {
          monitored
          moistureDevices
          theftPreventionDevices
          motionDetectingDevices
          smokeDetectingDevices
          autoWaterShutoffDevices
          providerName
          agreeToTerms
        }
        multiPolicyDiscount
        underwritingChanges
        homeViolationDates
        homeSingleViolationDates
      }
    }
  }
  ${fragments.Address}
  ${fragments.People}
  ${OFFER_FRAGMENT}
`;
